// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"ad6a2ef6","301":"63e72174","371":"3b7eb62c"}[chunkId] + ".chunk.js";
};